/* Cortisol-LP (lpl-*) · Slider-Punkte und Paketauswahl. Ohne Abhängigkeiten. */
(function () {
  function initSlider(root) {
    if (root.dataset.lplReady) return;
    root.dataset.lplReady = '1';
    var track = root.querySelector('.lpl-slider__track');
    var dots = root.querySelector('[data-lpl-dots]');
    if (!track || !dots) return;
    var slides = track.querySelectorAll('.lpl-slider__slide');
    dots.innerHTML = '';
    slides.forEach(function (slide, i) {
      var dot = document.createElement('span');
      dot.className = 'lpl-slider__dot';
      dot.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });
    function update() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      slides.forEach(function (slide, i) {
        var left = slide.offsetLeft - track.offsetLeft;
        if (left <= center) active = i;
      });
      dots.querySelectorAll('.lpl-slider__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initOffer(form) {
    if (form.dataset.lplReady) return;
    form.dataset.lplReady = '1';
    var button = form.querySelector('[data-lpl-offer-button]');
    form.addEventListener('change', function (event) {
      var label = event.target.closest('.lpl-package');
      if (label && button && label.dataset.buttonLabel) button.textContent = label.dataset.buttonLabel;
    });
  }

  // Paketauswahl absenden: über den Shopify-Warenkorb-Link /cart/VARIANTE:1.
  // Er legt einen frischen Warenkorb mit genau diesem Paket an und öffnet direkt die Kasse –
  // vorher gewählte Pakete werden nicht aufaddiert (wie auf /pages/stress-cortisol-alle-angebot).
  // Als reine Seitennavigation kann ihn auch XBoost (Slide-Cart) nicht abfangen.
  function submitOffer(form) {
    var input = form.querySelector('input[name="id"]:checked');
    if (!input || !input.value || form.dataset.lplBusy) return;
    form.dataset.lplBusy = '1';
    var button = form.querySelector('[data-lpl-offer-button]');
    if (button) button.setAttribute('aria-busy', 'true');
    var cartUrl = (form.dataset.cartUrl || '/cart').replace(/\/$/, '');
    window.location.href = cartUrl + '/' + encodeURIComponent(input.value) + ':1';
  }

  // Im Capture-Durchlauf abfangen, bevor Warenkorb-Apps den Klick übernehmen (nur bei „direkt zur Kasse“)
  function interceptOffer(event) {
    // Buttons mit Aktion „Gewähltes Paket direkt zur Kasse“ (z. B. „30 Tage risikofrei testen“)
    var checkoutButton = event.type === 'click' && event.target.closest && event.target.closest('[data-lpl-checkout]');
    if (checkoutButton) {
      var offer = document.querySelector('[data-lpl-offer]');
      if (!offer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      submitOffer(offer);
      return;
    }
    var form = event.target.closest && event.target.closest('[data-lpl-offer]');
    if (!form || form.dataset.goToCheckout !== 'true') return;
    if (event.type === 'click' && !event.target.closest('[data-lpl-offer-button]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitOffer(form);
  }
  window.addEventListener('click', interceptOffer, true);
  window.addEventListener('submit', interceptOffer, true);
  // Zurück-Taste aus der Kasse: Seite kommt aus dem Cache, Sperre wieder lösen
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-lpl-offer]').forEach(function (form) {
      delete form.dataset.lplBusy;
      var button = form.querySelector('[data-lpl-offer-button]');
      if (button) button.removeAttribute('aria-busy');
    });
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-lpl-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-lpl-offer]').forEach(initOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Theme-Editor: neu geladene Sections initialisieren
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
